import { Component } from '@angular/core';

/**
 * PageContent Component
 *
 * A wrapper component that provides consistent page layout with:
 * - Menu bar at the top (fixed)
 * - Scrollable content area
 * - Rim border-radius effect
 *
 * Usage:
 * <app-page-content>
 *   <app-doenkids-menu-bar menuBar>...</app-doenkids-menu-bar>
 *   <div content>Page content here</div>
 * </app-page-content>
 */
@Component({
  selector: 'app-page-content',
  standalone: true,
  templateUrl: './page-content.component.html',
  styleUrl: './page-content.component.scss'
})
export class PageContentComponent {}
